export default (state) => state.lazy || {};
